import { ModifyReviewState, Review } from 'common/types/entities/api/review'
import { StateKey } from 'common/utils/flipState'

export const initialState: ModifyReviewState = {
  result: null,
  hasResultUpdated: false,
}

const INIT = 'review/modify/INIT'
const SET_RESULT = 'review/modify/SET_RESULT'

export const initModifyReview = (curState: StateKey) => dispatch => {
  dispatch({
    curState,
    type: INIT,
  })
}

export const setResultOfModifyReview = (curState: StateKey, form: Review) => dispatch => {
  dispatch({
    curState,
    type: SET_RESULT,
    result: form,
    hasResultUpdated: true,
  })
}

const modifyReviewReducer = (state = initialState, action) => {
  const { type, result, hasResultUpdated } = action

  switch (type) {
    case INIT:
      return state
    case SET_RESULT:
      return {
        ...state,
        result,
        hasResultUpdated,
      }
    default:
      return state
  }
}

export default modifyReviewReducer
